import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Plus, Play } from 'lucide-react';
import { PrimaryButton, SuccessButton } from '../touchable';

interface HomeEmptyStateProps {
  onNewProject: () => void;
  onJustKnit: () => void;
}

export const HomeEmptyState: React.FC<HomeEmptyStateProps> = ({ onNewProject, onJustKnit }) => {
  const { t } = useTranslation('session');
  return (
    <div className="flex flex-col items-center text-center gap-5 py-8">
      <div aria-hidden className="text-5xl">🧶</div>
      <div>
        <h2 className="text-2xl font-black text-ink">{t('home.empty.title', "Let's cast on")}</h2>
        <p className="text-ink-faint mt-2 max-w-xs mx-auto">
          {t(
            'home.empty.body',
            'Track rows, time your knitting, and watch your activity calendar grow.',
          )}
        </p>
      </div>
      <div className="w-full max-w-xs space-y-3">
        <PrimaryButton onClick={onNewProject} className="py-4 rounded-3xl font-black flex items-center justify-center gap-2">
          <Plus className="w-5 h-5" strokeWidth={3} />
          {t('home.actions.newProject', 'NEW PROJECT')}
        </PrimaryButton>
        <SuccessButton onClick={onJustKnit} className="py-4 rounded-3xl font-extrabold flex items-center justify-center gap-2">
          <Play className="w-5 h-5" fill="currentColor" />
          {t('home.actions.justKnit', 'JUST KNIT')}
        </SuccessButton>
      </div>
      <Link to="/learn/getting-started/" className="text-sm font-bold text-primary hover:underline">
        {t('home.empty.gettingStarted', 'New here? Getting started →')}
      </Link>
    </div>
  );
};
